window.addEventListener('load', function() {

  if(!document.querySelector('.single-product'))
    return;

  const wc_variations_form = document.querySelector('form.variations_form.cart');
  const wc_variation_select = wc_variations_form.querySelector('select#pa_product_type');
  const wc_variation_submit = wc_variations_form.querySelector('button.single_add_to_cart_button');
  const ch_variations = document.querySelectorAll('.js_variations__variation');
  const ch_add_to_cart_buttons = document.querySelectorAll('.js_add_to_cart_button');

  ch_variations.forEach((variation) => {

    variation.addEventListener('click', function(){

      // Select only current variation
      ch_variations.forEach((unselectedVariation) => {
        unselectedVariation.classList.remove('is_active');
      });
      variation.classList.add('is_active');

      // Change native varation select value
      wc_variation_select.value = variation.dataset.slug;
      $(wc_variation_select).trigger('change');

    });

    variation.querySelector('.js_add_to_cart_button').addEventListener('click', function(){

      // Change native quantity value
      wc_variations_form.querySelector('.quantity input.qty').value = (variation.dataset.slug == 'physique')
        ? variation.querySelector('.js_variations__variation__quantity').value : 1;
      $(wc_variation_select).trigger('change');

      // Emulate the "Add to cart" click
      wc_variation_submit.click();

    });
  });


});

